import Cookies from 'js-cookie';
import {ensureSessionIsActive, logoutAndRedirect, renewActiveSession} from './session';

export function mergeAuthHeaders(headers) {
    const token = Cookies.get('authToken');
    const merged = {...(headers || {})};
    if (token) {
        merged['Authorization'] = `Bearer ${token}`;
        // Compatibilidade com backend legado em produção.
        merged['Useruuid'] = token;
    }
    return merged;
}

class HttpError extends Error {
    constructor(statusCode, message) {
        super(message);
        this.statusCode = statusCode;
        this.name = 'HttpError';
    }
}

function isLoginScreen() {
    return typeof window !== 'undefined' && window.location?.pathname === '/login';
}

export function makeRequest(url, method, headers, body, timeout = 5000, retries = 5) {
    const isLoginRequest = url.includes('/api/users/login');
    const hasAuthToken = !!Cookies.get('authToken');
    if (!isLoginScreen() && !isLoginRequest && hasAuthToken && !ensureSessionIsActive()) {
        logoutAndRedirect();
        return Promise.reject(new HttpError(401, 'Session expired'));
    }

    const options = {
        method: method,
        headers: mergeAuthHeaders(headers),
        body: body
    };

    let retryCount = 0;

    const fetchWithTimeout = (url, options) => {
        return Promise.race([
            fetch(url, options),
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Request timed out')), timeout)
            ),
        ]);
    };

    const attemptRequest = () => {
        return fetchWithTimeout(url, options)
            .then(response => {
                if (response.status === 401 || response.status === 403) {
                    logoutAndRedirect();
                    throw new HttpError(response.status, response.status === 401 ? 'Unauthorized' : 'Forbidden');
                }
                if (!response.ok) {
                    throw new HttpError(response.status, `Request error: ${response.statusText}`);
                }
                renewActiveSession();
                if (method === 'DELETE') {
                    return response;
                }
                return response.json();
            })
            .catch(error => {
                if (error instanceof HttpError && (error.statusCode === 401 || error.statusCode === 403)) {
                    throw error;
                }
                retryCount++;
                if (retryCount < retries) {
                    console.log(`Retrying (${retryCount}/${retries})...`);
                    return attemptRequest();
                } else {
                    console.error('Request error:', error);
                    throw error;
                }
            });
    };

    return attemptRequest();
}